<template>
  <div class="height-100">
    <div class="background"></div>

    <div class="wrapper">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container">
          <div v-if="this.$route.params.brand">
            <router-link
              v-if="!this.$route.params.brand"
              class="navbar-brand"
              :to="{
                name: 'brandHome',
                params: { brand: this.$route.params.brand },
              }"
            >
              <img src="/img/logo.png" />
            </router-link>
            <router-link
              v-if="this.$route.params.brand == 'greetz'"
              class="navbar-brand"
              :to="{
                name: 'brandHome',
                params: { brand: this.$route.params.brand },
              }"
            >
              <img src="/img/greetz.png" />
            </router-link>
          </div>

          <button
            class="navbar-toggler pl-2 pr-2"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="material-icons">menu</i>
          </button>
          <div
            v-if="this.$route.params.brand"
            class="collapse navbar-collapse"
            id="navbar"
          >
            <ul class="navbar-nav">
              <li class="nav-item active">
                <router-link
                  active-class="active"
                  class="nav-link"
                  :to="{
                    name: 'brandHome',
                    params: { brand: this.$route.params.brand },
                  }"
                  exact
                  >New Incident</router-link
                >
              </li>
              <li class="nav-item active">
                <router-link
                  active-class="active"
                  class="nav-link"
                  :to="{
                    name: 'bug',
                    params: { brand: this.$route.params.brand },
                  }"
                  >Report a Bug</router-link
                >
              </li>
              <li class="nav-item active">
                <router-link
                  active-class="active"
                  class="nav-link"
                  :to="{
                    name: 'incidents',
                    params: { brand: this.$route.params.brand },
                  }"
                  >View Incidents</router-link
                >
              </li>
              <li class="nav-item active">
                <router-link
                  active-class="active"
                  class="nav-link"
                  :to="{
                    name: 'faq',
                    params: { brand: this.$route.params.brand },
                  }"
                  >FAQ</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <!--
            <div class="alert alert-danger text-center" role="alert">
                Down time notification message on <strong>Saturday xx xxx xxxx from xx:xx until xx:xx </strong><br/>
                During this time please manually raise any incidents in the incidents slack channel
            </div>
-->
      <router-view />

      <div class="push"></div>
    </div>

    <div class="footer pt-4 pb-4 bg-white">
      <div v-if="this.$route.params.brand" class="container text-center">
        <p>
          This is the
          <strong>Moonpig Group Incident Management Process</strong> and is
          intended for internal use only.
        </p>
        <ul v-if="this.$route.params.brand == 'moonpig'" class="list-inline">
          <li class="list-inline-item">
            <a target="_blank" href="https://greetz.atlassian.net/projects/MINC"
              >JIRA Project</a
            >
          </li>
          <li class="list-inline-item">
            <a
              target="_blank"
              href="https://moonpig-group.slack.com/archives/CUSELL9A6"
              >Slack Incidents Channel</a
            >
          </li>
          <li class="list-inline-item">
            <a
              target="_blank"
              href="https://moonpig-group.slack.com/archives/C011BA58139"
              >Slack Incident Management Channel</a
            >
          </li>
        </ul>
        <ul v-if="this.$route.params.brand == 'greetz'" class="list-inline">
          <li class="list-inline-item">
            <a target="_blank" href="https://greetz.atlassian.net/browse/GRTINC"
              >JIRA Project</a
            >
          </li>
          <li class="list-inline-item">
            <a
              target="_blank"
              href="https://slack.com/app_redirect?channel=CSQUVURA4"
              >Slack Incidents Channel</a
            >
          </li>
          <li class="list-inline-item">
            <a
              target="_blank"
              href="https://slack.com/app_redirect?channel=CSQUVURA4"
              >Slack Incident Management Channel</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
